<template>
  <footer class="main-footer">
    <strong>Copyright &copy; 2020 <a href="https://agar.rs">Agar Balkan</a>.</strong> All
    rights
    reserved.
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?55f27056